import { useEffect, useState } from "react";
import {
  useDeleteMessageById,
  useGetMessageById,
  useGetMessages,
} from "../../../hooks/Messages";
import { Message } from "../../../services/Api/swagger";
import { useQueryClient } from "react-query";

export const useMessages = () => {
  const {
    error: errorMessages,
    isLoading: isFetchingMessages,
    data: messages,
    refetch: useRechercherMessages,
  } = useGetMessages();
  const {
    mutate: deleteMessageById,
    error: errorDeleteMessage,
    isLoading: isFetchingDeleteMessage,
    isSuccess: isSuccessDeleteMessage,
    reset: resetDeleteMutation,
  } = useDeleteMessageById();

  const [selectedId, setSelectedId] = useState<number>();
  const [open, setOpen] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);

  const handleConsulter = (id: number) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleDelete = (id: number) => {
    setSelectedId(id);
    setOpenConfirm(true);
  };

  const handleConfirm = () => {
    if (selectedId) {
      deleteMessageById(selectedId);
    }
    setOpenConfirm(false);
  };

  const queriesClient = useQueryClient();
  useEffect(() => {
    if (isSuccessDeleteMessage) {
      queriesClient.invalidateQueries("messages");
    }
  }, [isSuccessDeleteMessage]);

  let searchResults: Message[] = messages || [];
  return {
    deleteMessageById,
    errorDeleteMessage,
    isFetchingDeleteMessage,
    isSuccessDeleteMessage,
    resetDeleteMutation,
    errorMessages,
    isFetchingMessages,
    messages,
    searchResults,
    open,
    useRechercherMessages,
    handleConsulter,
    handleDelete,
    handleConfirm,
    selectedId,
    setOpen,
    setSelectedId,
    openConfirm,
    setOpenConfirm,
  };
};
